import React from 'react';
import InformationSvg from '@atlas-design-system/core/dist/svg/information.svg';

import IconBase from './IconBase';

const InformationIcon = React.forwardRef((props, ref) => (
  <IconBase {...props} ref={ref} Icon={InformationSvg} />
));

InformationIcon.displayName = 'InformationIcon';

export default InformationIcon;
